module.exports = __webpack_public_path__ + "img/NS仙人白黒反転.3fea2b8e.png";